module.exports = __webpack_public_path__ + "media/images/common/about/icon_urgentflight-daca7d5e6cab7217173b393a7cef6076.png";